import React, { useEffect } from 'react';

const injectZohoBot = (url, widgetCode) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.defer = true;

  const code = `
    var $zoho = $zoho || {};
    $zoho.salesiq = $zoho.salesiq || {
      widgetcode: "${widgetCode}",
      values: {},
      ready: function() {
        $zoho.salesiq.customfield.add({
          name: "_default.question",
          hint: "¡Bienvenido a GoTrenes! Describa brevemente el motivo de su consulta para una respuesta más rápida y eficaz. Si tiene un número de reserva, indíquelo para poder asistirle. ¡Gracias!"
        });
        $zoho.salesiq.floatwindow.visible("hide");
      }
    };
    var d = document, s = d.createElement("script");
    s.type = "text/javascript";
    s.id = "zsiqscript";
    s.defer = true;
    s.src = "${url}";
    var t = d.getElementsByTagName("script")[0];
    t.parentNode.insertBefore(s, t);
    d.innerHTML = "<div id='zsiqwidget'></div>";
  `;

  script.appendChild(document.createTextNode(code));
  document.body.appendChild(script);

  return script;
};

const useZohoBot = (url, widgetCode, show) => {
  useEffect(() => {
    let script;

    if (show) {
      script = injectZohoBot(url, widgetCode);
      document.querySelector('[data-id=zsalesiq]')?.classList?.remove('hidden');
    } else {
      document.querySelector('[data-id=zsalesiq]')?.classList?.add('hidden');
    }

    return () => {
      if (script) document.body.removeChild(script);
    };
  }, [url, widgetCode, show]);
};

export default function ZohoBot({ showZohoBot }) {
  useZohoBot(
    'https://salesiq.zoho.com/widget',
    '55d893b31b577635128f7a49bd1800f33ad41c180f2e687953a08fe8772078341a2010ab7b6727677d37b27582c0e9c4',
    showZohoBot
  );

  return null;
}
